import z from 'zod';

////////
// Core shared types used amongst multiple entities
////////
export const entitySchema = z.object({
    id: z.number().int(),
});

export const auditableSchema = z.object({
    createdDate: z.coerce.date(),
    createdByUserId: z.number().int(),
    modifiedDate: z.coerce.date().optional().nullable(),
    modifiedByUserId: z.number().int().optional().nullable(),
});

////////
// Core shared types used amongst multiple api requests/responses
////////
export const paginationParamsSchema = z.object({
    pageNumber: z.number().int(),
    pageSize: z.number().int(),
    sortBy: z.string().nullable().optional(),
    sortDir: z.string().nullable().optional(),
});

export const responseBaseSchema = z.object({
    isError: z.boolean(),
    errors: z.array(z.object({ message: z.string() })),
});

export const mutationResponseSchema = z.object({
    ...entitySchema.shape,
    ...responseBaseSchema.shape,
});

// A generic builder function to create a paginated response schema
export const PaginatedResponseBuilder = <T extends z.ZodTypeAny>(itemSchema: T) =>
    z.object({
        ...responseBaseSchema.shape,
        results: z.array(itemSchema),
        totalCount: z.number(),
        columnOrder: z.array(z.string()).optional(),
    });

export type Entity = z.infer<typeof entitySchema>;
export type Auditable = z.infer<typeof auditableSchema>;
export type PaginationParams = z.infer<typeof paginationParamsSchema>;
export type MutationResponse = z.infer<typeof mutationResponseSchema>;
